import React, { useState, useEffect, useRef } from "react";
import { AiOutlineSearch, AiFillStar } from "react-icons/ai";
import { FaRegTimesCircle } from "react-icons/fa";
import { BiUserCircle, BiCartAlt } from "react-icons/bi";
import { BsChevronDown, BsArrowUpRight } from "react-icons/bs";
import { BiTimeFive } from "react-icons/bi";
import { MdLocationPin } from "react-icons/md";
import { ImCross } from "react-icons/im";
import { RESET_FEDBACK } from "../../Redux/Constants";
import { ToggleMenu } from "../New-Dashboard/UserProfile";
import { NavLink, useHistory } from "react-router-dom";
import metroCross from "../../Assets/metroCross.svg";
import { Link } from "react-scroll";
import {
  getAllPackageList,
  getCartDetails,
  AddFeedback,
  getCity,
  setCity,
  EmptyCart,
  getCurrentLocation,
} from "../../Redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-responsive-modal";
import NewPhoneModel from "../../Pages/homePage/Components/NewPhoneModel";
import "react-responsive-modal/styles.css";

import Loader from "../Loader/Loader";
import "./NewDesktopHeader.css";
import OutsideAlerter from "../CustomHooks/OutSideClick";

//image logo lin
//   dispatch(getCartDetails(userProfile?.token, citySelect));
function NewDesktopHeader({ faq }) {
  const feedBackStatus = useSelector((state) => state.AddFeedbackReducer);
  const cityCurrent = useSelector((state) => state.getCurrentLocationReducer);

  const { loading: feedbackLoading, status } = feedBackStatus;
  const history = useHistory();
  const [feedbackPhone, setFeedbackPhone] = useState("");
  const [feedbackPhoneError, setFeedbackPhoneError] = useState("");
  var isFeedBackNumber = null;

  const validateContantInfo = (val) => {
    let phoneno = /^\d{10}$/;
    let regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (val.match(phoneno) && parseInt(val[0]) >= 6) {
      isFeedBackNumber = true;
      return true;
    } else if (regex.test(val)) {
      isFeedBackNumber = false;
      return true;
    } else {
      if (isNaN(val)) {
        setFeedbackPhoneError("Enter valid details");
      } else {
        setFeedbackPhoneError("Enter valid details");
      }
      return false;
    }
  };

  //FEEDBACK MESSAGE
  const [feebackError, setFeedbackError] = useState("");
  const [feedbackMsg, setFeedback] = useState("");

  const [disable, setDisable] = useState(false);

  useEffect(() => {
    if (feedbackPhone == "" || feedbackMsg == "" || feebackError !== "" || feedbackPhoneError !== "") {
      setDisable(true)
    } else {
      setDisable(false)
    }
  }, [feedbackPhone, feedbackMsg, feebackError, feedbackPhoneError])
  const sendFeedback = (e) => {
    e.preventDefault();
    if (validateContantInfo(feedbackPhone)) {
      var body = {};
      if (isFeedBackNumber) {
        body = {
          content: feedbackMsg,
          mobile: feedbackPhone,
        };
      } else {
        body = {
          content: feedbackMsg,
          email: feedbackPhone,
        };
      }

      dispatch(AddFeedback(body));
      setFeedback("");
      setFeedbackPhone("");
      setFeedbackPhoneError("");
    }
  };
  useEffect(() => {
    if (feedbackPhone == "") {
      setFeedbackPhoneError("");
    }
  }, [feedbackPhone]);

  //RECENT MESSAGE ARRAY
  const [recentSearches, setRecentSearches] = useState([]);
  const [show, setShow] = useState(false);
  const [openImg, setOpenImg] = useState(false);
  const [searchValue, setSearch] = useState("");
  const dispatch = useDispatch();
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [open, setOpen] = useState(false);
  const cart = useSelector((state) => state.CartReducer);
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;
  const [login, setLogin] = useState(false);

  const onCloseModalImg = () => setOpenImg(false);
  //Getting Search Value
  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (userDetails && userDetails?.token) {
      setLogin(true);
    } else {
      setLogin(false);
    }
    const token = userDetails && userDetails?.token;

    searchValue.length > 2
      ? dispatch(getAllPackageList(searchValue !== "" && searchValue, token))
      : null;
  }, [searchValue !== "" && searchValue, login]);

  // GETTING CART DETAILS
  const cartDetails = useSelector((state) => state.CartReducer);
  const { loading: cartLoading } = cartDetails;
  const [cartLength, setCartLength] = useState(0);

  useEffect(() => {
    if (!cartLoading) {
      cartDetails &&
        cartDetails.cartDetails &&
        cartDetails.cartDetails[0] &&
        cartDetails.cartDetails[0].product.length > 0
        ? setCartLength(cartDetails.cartDetails[0].product.length)
        : setCartLength(0);
    }
  }, [cartLoading]);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    const token = userDetails && userDetails.token;
    if (token) {
      dispatch(getCartDetails(token, citySelect));
    }
    dispatch(getCity());
  }, []);
  //GETTING CITY DETAILS

  const navCity = useSelector((state) => state.navCityList);
  const { navCities, loading: cityLoading } = navCity;

  //selecting userData
  const selectingData = useSelector((state) => state.allpackage);
  const { loading, AllpackDetail } = selectingData;

  //handelSearch
  const handelSearch = (e) => {
    setDisplay1(true);
    setSearch(e.target.value);
  };

  const handelSearchClick = (data) => {
    setSearch("");
    console.log("clicked >>>>");
    const oldrecentSearch =
      localStorage.getItem("recentSearches") &&
        localStorage.getItem("recentSearches") !== ""
        ? JSON.parse(localStorage.getItem("recentSearches"))
        : [];
    console.log(oldrecentSearch.length, "oldreacentSearch >>>>");
    if (oldrecentSearch?.length > 5) {
      oldrecentSearch.pop();
    }

    const changedArray = oldrecentSearch.filter((val) => {
      return val.slug !== data.slug;
    });
    console.log(changedArray, "changedArray >>>>");

    localStorage.setItem(
      "recentSearches",
      JSON.stringify([{ name: data.name, slug: data.slug }, ...changedArray])
    );

    console.log(data, "before history push >>>>");
    history.push(
      `${data.slug}${citySelect ? `-${citySelect.toLowerCase().replace(" ", "-")}` : ""
      }`
    );
  };

  //handel clear recent
  const removeRecent = () => {
    setRecentSearches([]);
    localStorage.setItem("recentSearches", JSON.stringify([]));
  };

  //delete snglr
  const deleteThis = (slug) => {
    const filteredRecent = recentSearches.filter((searches) => {
      return searches.slug !== slug;
    });
    setRecentSearches(filteredRecent);
    localStorage.setItem("recentSearches", JSON.stringify(filteredRecent));
  };
  useEffect(() => {
    setRecentSearches(
      localStorage.getItem("recentSearches") &&
        localStorage.getItem("recentSearches") !== ""
        ? JSON.parse(localStorage.getItem("recentSearches"))
        : []
    );
  }, [searchValue]);

  useEffect(() => {
    setRecentSearches(
      localStorage.getItem("recentSearches") &&
        localStorage.getItem("recentSearches") !== ""
        ? JSON.parse(localStorage.getItem("recentSearches"))
        : []
    );
  }, []);

  //handelcity
  const successCd = () => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    dispatch(
      getCartDetails(userProfile.token, citySelected && citySelected.citySelect)
    );
  };

  useEffect(() => {
    const city = localStorage.getItem("city");
    if (city != "" && city != null) {
      dispatch(setCity(city));
    }
  }, []);

  const [display1, setDisplay1] = useState(false);
  const [display2, setDisplay2] = useState(false);
  const [display, setDisplay] = useState(false);
  const handelCity = (city) => {
    // console.log(city, "<<<<");
    const userProfile = JSON.parse(localStorage.getItem("user"));
    localStorage.setItem("city", city);
    setSearchCity(city);
    dispatch(setCity(city != "" ? city : ""));
    setDisplay(false);
    // e.target.blur();
    // userProfile && userProfile !== ""
    //   ? dispatch(EmptyCart(userProfile && userProfile.token, successCd))
    //   : null;
  };

  useEffect(() => {
    handelCity(citySelect && citySelect);
  }, [citySelect]);

  //success
  const [successdiv, setSuccssDiv] = useState(false);
  useEffect(() => {
    if (feedBackStatus && feedBackStatus?.feedbackSent) {
      setSuccssDiv(true);
    } else {
      setSuccssDiv(false);
    }
  }, [feedBackStatus, feedBackStatus?.feedbackSent]);

  const onOpenModalImg = () => {
    const user = localStorage.getItem("user");

    if (!user) {
      history.push("/imaging");
    } else if (
      cart?.cartDetails &&
      cart?.cartDetails?.message == "cart is empty"
    ) {
      history.push("/imaging");
    } else if (
      cart?.cartDetails &&
      cart?.cartDetails[0]?.product?.length == 0
    ) {
      history.push("/imaging");
    } else {
      setOpenImg(true);
    }
  };

  const handleSubmit = () => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    if (userProfile && userProfile !== "") {
      dispatch(EmptyCart(userProfile && userProfile.token));
      setTimeout(() => {
        history.push("/imaging");
      }, 400);
    } else {
      history.push("/imaging");
    }
  };
  //
  const handelClose = () => {
    dispatch({
      type: RESET_FEDBACK,
    });

    setShow(!show);
  };

  //
  const getLoc = () => {
    dispatch(getCurrentLocation());
  };

  const [searchCity, setSearchCity] = useState("");

  const [cityArry, seCityArry] = useState([]);

  const handelPhone = (e) => {
    setFeedbackPhone(e.target.value);
    setFeedbackPhoneError("");
  };




  const handelFeedback = (e) => {
    setFeedback(e.target.value)
    const characterRegex = /^([A-Za-z0-9]+[ ]?)+$/;
    setFeedbackError("");
    if (!e.target.value.match(characterRegex)) {
      setFeedbackError("Invalid feedback");
    }
    if (e.target.value == "") {
      setFeedbackError("");
    }
  }
  return (
    <>
      <div className="newHeader">
        <div className="header_container">
          <div className="header_top">
            <div className="header_logo">
              <a href={process.env.RAZZLE_APP_BASE_URL} className="header_logo">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a0f82e2b-5cee-4694-a972-2514e9bd3694.svg"
                  width="100%"
                />
              </a>
            </div>

            <div className="header_midSection">
              <div className="header_searchBar dis_flex">
                <div className="selectAreaPincode">
                  <OutsideAlerter
                    onClickOut={() => {
                      setDisplay(false);
                    }}
                  >
                    <div className="citySelectHome">
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <input
                          style={{ width: "120px" }}
                          className="cityDrop_model"
                          value={searchCity.replace("_", " ")}
                          onFocus={(e) => {
                            e.target.select(), setDisplay(true);
                          }}
                          onChange={(e) => {
                            setSearchCity(e.target.value.replace(" ", "_")),
                              setDisplay(true);
                          }}
                          placeholder="search city"
                        />
                      </form>
                      {display ? (
                        <div className="divCity divCity2" defaultValue="Noida">
                          <span
                            onClick={() => {
                              setDisplay(false),
                                setSearchCity(""),
                                handelCity("");
                            }}
                            value=""
                          >
                            Select City
                          </span>
                          {navCity &&
                            navCity.navCities &&
                            navCity.navCities.cities ? (
                            navCity.navCities.cities
                              .filter((city, index) => {
                                if (searchCity == "") {
                                  return city;
                                } else if (
                                  city
                                    .toLowerCase()
                                    .includes(searchCity.toLowerCase())
                                ) {
                                  return city;
                                }
                              })
                              .map((ele, index) => {
                                // console.log(ele.replace("_", " "), "<<<<");
                                return (
                                  <span
                                    onClick={() => handelCity(ele)}
                                    key={index}
                                    selected={ele == citySelected.citySelect}
                                    value={ele}
                                  >
                                    {ele.replace("_", " ")}
                                  </span>
                                );
                              })
                          ) : (
                            <Loader />
                          )}
                        </div>
                      ) : null}
                    </div>
                  </OutsideAlerter>
                  <div className="verticalLine" />
                  {/* <div className="selectPincode">
                    <div className="disFlex_column flex-justify">
                      <span className="selectAddress addressFontBold ">
                        Select Address
                      </span>
                      <span>You can add from your addresses</span>
                    </div>
                    <div className="userAddress">
                      <div className="dis_flex flex-justify">
                        <label className="addressFontBold">Lokesh</label>
                        <input
                          value=""
                          type="radio"
                          style={{ width: "auto" }}
                        />
                      </div>
                      <div style={{ marginTop: "1rem" }}>
                        <p className="addrespara">
                          007, Venice Beach, Omaha Estate, 42142
                        </p>
                      </div>
                    </div>
                    <div className="border_horizontal" />
                    <div className="disFlex_column flex-justify">
                      <span className="selectAddress addressFontBold ">
                        Or Enter Pincode
                      </span>
                      <span>Select Pincode to see checkup availability</span>
                      <div className="pincodeInput ">
                        <MdLocationPin />
                        <input placeholder="Enter Pincode" type="text" />
                      </div>
                    </div>
                    <div className="border_horizontal" />
                    <div className="getLocation">
                      <img
                        src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/3311e52a-a954-496c-b4c1-38d9cc1700dc.png"
                        width="20px"
                      />

                      <h4 onClick={getLoc} className="danger">
                        Detect from my location
                      </h4>
                    </div>
                  </div> */}
                </div>

                <div className="searchInput">
                  <OutsideAlerter
                    onClickOut={() => {
                      setDisplay1(false);
                    }}
                  >
                    <div className="searchInput searchInput2">
                      <input
                        type="text"
                        value={searchValue}
                        placeholder="Search for health package or tests"
                        onFocus={(e) => {
                          e.target.select(), setDisplay1(true);
                        }}
                        onChange={handelSearch}
                      />
                      <AiOutlineSearch />
                      {display1 ? (
                        <div className="recentSearches searchEdit searchEdit2">
                          <h4 style={{ fontWeight: "500", margin: "1rem" }}>
                            {searchValue == "" || searchValue.length < 3 ? (
                              recentSearches.length > 0 ? (
                                <div className="recentDiv">
                                  <span className="noPointer">
                                    {" "}
                                    <BiTimeFive
                                      style={{
                                        marginRight: "1rem",
                                        fontSize: "2rem",
                                      }}
                                    />{" "}
                                    Recent searches{" "}
                                  </span>
                                  <span
                                    className="danger"
                                    onClick={removeRecent}
                                  >
                                    Clear History
                                  </span>
                                </div>
                              ) : null
                            ) : searchValue.length > 2 &&
                              AllpackDetail &&
                              AllpackDetail?.count > 0 ? (
                              `Found ${AllpackDetail?.count} results `
                            ) : recentSearches?.length > 0 ? (
                              <div className="recentDiv">
                                {/* <span className="noPointer"> Recent searches </span>
                            <span onClick={removeRecent} className="danger">
                              Clear History
                            </span> */}
                              </div>
                            ) : null}
                          </h4>

                          <ul className="recentList">
                            {loading ? (
                              <Loader />
                            ) : searchValue !== "" &&
                              searchValue.length > 2 &&
                              AllpackDetail &&
                              AllpackDetail?.results &&
                              AllpackDetail?.results?.length > 0 ? (
                              AllpackDetail?.results?.map((values) => {
                                return (
                                  <li
                                    className="deadState"
                                    key={values.id}
                                    onClick={() => handelSearchClick(values)}
                                  >
                                    {/* <BiTimeFive />{" "} */}
                                    <span>{values.name}</span>
                                    <BsArrowUpRight />
                                  </li>
                                );
                              })
                            ) : searchValue !== "" && searchValue.length > 2 ? (
                              <p style={{ margin: "1.2rem" }}>
                                No Packages Found
                              </p>
                            ) : recentSearches && recentSearches.length > 0 ? (
                              recentSearches.map((values, index) => (
                                <li className="deadState" key={index}>
                                  <div
                                    className="danger cross"
                                    onClick={() => deleteThis(values.slug)}
                                  >
                                    <ImCross />
                                  </div>
                                  <NavLink
                                    to={`/${values.slug}${citySelect
                                      ? `-${citySelect
                                        .toLowerCase()
                                        .replace(" ", "-")}`
                                      : ""
                                      }`}
                                  >
                                    <span>{values.name}</span>
                                    <BsArrowUpRight />
                                  </NavLink>
                                </li>
                              ))
                            ) : null}
                          </ul>
                          <h4
                            style={{ fontWeight: "500", margin: "1rem " }}
                            className="noPointer"
                          >
                            Popular Searches
                          </h4>
                          <ul className="recentList">
                            <li className="deadState ">
                              <NavLink
                                to={`/advance-full-body-checkup${citySelect
                                  ? `-${citySelect
                                    .toLowerCase()
                                    .replace(" ", "-")}`
                                  : ""
                                  }`}
                              >
                                <div className="start">
                                  <AiFillStar />
                                </div>
                                <span>Advance Full Body Checkup</span>{" "}
                                <BsArrowUpRight />{" "}
                              </NavLink>
                            </li>

                            <li className="deadState ">
                              <NavLink
                                to={`/smart-full-body-checkup${citySelect
                                  ? `-${citySelect
                                    .toLowerCase()
                                    .replace(" ", "-")}`
                                  : ""
                                  }`}
                              >
                                <div className="start">
                                  <AiFillStar />
                                </div>
                                <span>Smart Full Body Checkup</span>{" "}
                                <BsArrowUpRight />{" "}
                              </NavLink>
                            </li>

                            <li className="deadState ">
                              <NavLink
                                to={`/uric-acid-test${citySelect
                                  ? `-${citySelect
                                    .toLowerCase()
                                    .replace(" ", "-")}`
                                  : ""
                                  }`}
                              >
                                <div className="start">
                                  <AiFillStar />
                                </div>
                                <span>Uric Acid Test </span> <BsArrowUpRight />
                              </NavLink>
                            </li>

                            <li className="deadState ">
                              <NavLink
                                to={`/vitamin-profile-test${citySelect
                                  ? `-${citySelect
                                    .toLowerCase()
                                    .replace(" ", "-")}`
                                  : ""
                                  }`}
                              >
                                <div className="start">
                                  <AiFillStar />
                                </div>
                                <span>Vitamin Profile test </span>{" "}
                                <BsArrowUpRight />{" "}
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </OutsideAlerter>
                </div>
              </div>
              <div className="header_uploadPrescriptionSection dis_flex hoverGreen">
                {login ? (
                  <NavLink
                    to={{
                      pathname: `/uploadprescription`,
                    }}
                  >
                    <span className="dis_flex">
                      <img
                        src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/70657f15-6d40-49cc-9747-95d09d094929.svg"
                        width="15px"
                      />{" "}
                      &nbsp; Upload Prescription
                    </span>
                  </NavLink>
                ) : (
                  <NavLink
                    to={{
                      pathname: `/login`,
                      pushToUrl: "UploadPrescription",
                    }}
                  >
                    <span className="dis_flex">
                      <img
                        src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/70657f15-6d40-49cc-9747-95d09d094929.svg"
                        width="15px"
                      />{" "}
                      &nbsp; Upload Prescription
                    </span>
                  </NavLink>
                )}
              </div>

              <div className="header_cartSection dis_flex hoverState">
                <NavLink to={{ pathname: "/cart", pushToUrl: "cart" }}>
                  <BiCartAlt />

                  {login == true && cartLength > 0 ? (
                    <span className="cart_count">{cartLength}</span>
                  ) : null}

                  <span className="cart_text_color"> Cart </span>
                </NavLink>
              </div>

              <OutsideAlerter
                onClickOut={() => {
                  setDisplay2(false);
                }}
              >
                <div
                  className="header_profileSection hoverState dis_flex"
                  onClick={() => {
                    setDisplay2(true);
                  }}
                >
                  <BiUserCircle />{" "}
                  <span className="dis_flex svg profileText cart_text_color">
                    Profile <BsChevronDown />
                  </span>
                  {display2 ? (
                    <div className="dropDownlist">
                      <ToggleMenu
                        setCartLength={setCartLength}
                        isLoginfun={setLogin}
                      />
                    </div>
                  ) : null}
                </div>
              </OutsideAlerter>
            </div>
            <div className="horizontalLine"></div>
            <div className="callUs_section hoverState">
              <a href="tel:+918988988787">
                <span
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: 500,
                    color: "#2e2e2e",
                  }}
                >
                  Call us at
                </span>
                <span
                  className="highlightGreen"
                  style={{ fontWeight: 600, fontSize: "1.6rem" }}
                >
                  898 898 8787
                </span>
              </a>
            </div>
          </div>
        </div>
        <div className="border_horizontal" />
        <div className="header_bottom">
          <ul className="dis_flex ulforHeader">
            <NavLink
              className="Header_list hoverState"
              activeClassName="hoverStatective"
              to="/about-us"
            >
              About
            </NavLink>
            <NavLink
              className="Header_list hoverState"
              activeClassName="hoverStatective"
              to={`/health-checkup-packages${citySelect
                ? `-${citySelect.toLowerCase().replace(" ", "-")}`
                : ""
                }`}
            >
              Health Packages
            </NavLink>
            <div
              onClick={onOpenModalImg}
              style={{ color: "gray" }}
              className="Header_list hoverState"
            >
              Radiology
            </div>
            <NavLink
              className="Header_list hoverState"
              activeClassName="hoverStatective"
              to="/lab-centre-network"
            >
              Our Labs & Network
            </NavLink>
            <NavLink
              className="Header_list hoverState"
              activeClassName="hoverStatective"
              to="/blog"
            >
              Blogs
            </NavLink>
            <NavLink
              className="Header_list hoverState"
              activeClassName="hoverStatective"
              to="/gift-card"
            >
              Gift Card
            </NavLink>
            <NavLink
              className="Header_list hoverState"
              activeClassName="hoverStatective"
              to="/contact-us"
            >
              Contact Us{" "}
            </NavLink>
            {faq ? (
              <Link
                className="Header_list hoverState"
                to="faq"
                offset={-110}
                smooth={true}
                duration={0}
              >
                FAQs
              </Link>
            ) : null}

            {/* <NavLink
              className="Header_list hoverState"
              activeClassName="hoverStatective"
              to="/about"
            >Offers</NavLink> */}

            {/* <NavLink
              className="Header_list hoverState"
              activeClassName="ActiveClassLink"
              to="/about"
            >
              Offers
            </NavLink> */}
          </ul>
          <div className="requestCallback hoverState">
            <span onClick={onOpenModal}>REQUEST CALLBACK</span>
            <Modal open={open} onClose={onCloseModal} center>
              <NewPhoneModel />
            </Modal>
          </div>
        </div>
      </div>

      <div
        className={
          show
            ? "feedback feedbackNew  onScreen onScreenNew"
            : "feedback feedbackNew  offScreenNew"
        }
      >
        <div className="feedbackContent">
          <div className="feedbackForm feedbackFormNew">
            <form onSubmit={sendFeedback}>
              {successdiv ? (
                <div className="feedbackSent">
                  <p>Your feedback has been successfully sent</p>
                  <button
                    className="submit_primary submit_light  "
                    onClick={handelClose}
                  >
                    Close
                  </button>
                </div>
              ) : null}
              <p>
                Tell us about your query or how we can make our services better
              </p>
              <input
                className="feedBackPhone"
                required
                value={feedbackPhone}
                onChange={handelPhone}
                placeholder="Enter Phone Number/Email ID"
                type="text"
                name=""
                id=""
              />
              {feedbackPhoneError != "" ? (
                <span className="feedbackPhoneError">{feedbackPhoneError}</span>
              ) : null}
              <textarea
                placeholder="Write something"
                value={feedbackMsg}
                required
                onChange={handelFeedback}
              />
              <span className="error">{feebackError}</span>
              <div className="feedbackButton  ">
                <button
                  disabled={
                    disable
                      ? "disabled"
                      : ""

                  }
                  className={disable ? "disable submit_primary hoverGreen" : "submit_primary hoverGreen"}

                >Submit</button>
                <span
                  style={{ cursor: "pointer" }}
                  className="submit_primary submit_light  "
                  onClick={() => {
                    setShow(!show);
                    setFeedback("");
                    setFeedbackPhone("");
                    setFeedbackPhoneError("");
                  }}
                >
                  Cancel
                </span>
              </div>
            </form>
          </div>
          <span className="pinkFeedbackNew" onClick={handelClose}>
            Feedback&nbsp;
            {show ? <FaRegTimesCircle onClick={handelClose} /> : null}
          </span>
        </div>
        <Modal
          open={openImg}
          onClose={onCloseModalImg}
          // center
          classNames={{
            overlay: "customFooterOverlay",
            modal: "customFooterModal",
          }}
        >
          <div onClick={onCloseModalImg} className="modalCloseButton">
            <img className="crossButton" src={metroCross} alt="" />
          </div>
          <div className="footer-modal">
            <h2>Are you sure you want to empty your cart ?</h2>
            <div className="modal-inner">
              <a href={process.env.RAZZLE_APP_BASE_URL} className="modal-link" onClick={onCloseModalImg}>
                No
              </a>
              <div className="modal-link" onClick={handleSubmit}>
                Yes{" "}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default NewDesktopHeader;
